import React, { useEffect, useState } from 'react'
import * as Styles from './styles'
import FaqIcon from '../../../../components/Images/FaqIcon'
import RevisionIcon from '../../../../components/Images/RevisionIcon'
import PreviewIcon from '../../../../components/Images/PreviewIcon'
import SaveIcon from '../../../../components/Images/SaveIcon'
import ContentGuidelinesIcon from '../../../../components/Images/ContentGuidelinesIcon'
import WritingGuideIcon from '../../../../components/Images/WritingGuideIcon'
import { SecondaryButton } from '../../../../components/Button'
import { handleNotionOrExternalLink } from '../../../../lib/utils'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { handleNewEventLog } from '../../../../lib/utils/events'
import { PreviewPopup } from '../../../../components/Popup'

const ThreeDotsDropdownMenu = ({
  saveOptions,
  toggleRevisionsSideDrawer,
  showRevisionsIcon,
  user,
  novelDetails,
  chapter_id,
  getContent,
  title,
}) => {
  const [showPreview, setShowPreview] = useState(false)

  const createPreview = () => {
    return {
      __html: `${getContent()}`,
    }
  }

  useEffect(() => {
    handleNewEventLog(
      'chapter_editor',
      'novels_chapter_three_dots_menu_viewed',
      {
        route: window.location.pathname + window.location.search,
        module_name: 'chapter_editor_three_dots_menu',
        entity_id: chapter_id || 'Null',
        entity_type: 'chapter',
      },
      user,
      novelDetails
    )
  }, [])

  function logEvents(eventName, buttonName) {
    handleNewEventLog(
      'chapter_editor',
      eventName,
      {
        route: window.location.pathname + window.location.search,
        module_name: 'chapter_editor_three_dots_menu',
        button: buttonName,
        entity_id: chapter_id || 'Null',
        entity_type: 'chapter',
      },
      user,
      novelDetails
    )
  }

  return (
    <Styles.MenuWrapper>
      {saveOptions.showSaveIcon && (
        <Styles.ItemWrapper
          as={SecondaryButton}
          active={saveOptions.enabled}
          onClick={saveOptions.onClick}
          disabled={!saveOptions?.enabled}
        >
          <Styles.List>
            <SaveIcon />
            <Styles.ItemName>Save</Styles.ItemName>
          </Styles.List>
        </Styles.ItemWrapper>
      )}
      <Styles.ItemWrapper
        onClick={() => {
          setShowPreview(true)
          logEvents('novels_chapter_preview_clicked', 'preview')
        }}
      >
        <Styles.List>
          <PreviewIcon />
          <Styles.ItemName>Preview</Styles.ItemName>
        </Styles.List>
      </Styles.ItemWrapper>
      {showRevisionsIcon && (
        <Styles.ItemWrapper
          onClick={() => {
            handleNewEventLog(
              'chapter_editor',
              'novels_chapter_version_history_clicked',
              {
                route: window.location.pathname + window.location.search,
                module_name: 'chapter_editor_toolbar',
                entity_id: chapter_id || 'Null',
                entity_type: 'chapter',
              },
              user,
              novelDetails
            )
            toggleRevisionsSideDrawer(true)
          }}
        >
          <Styles.List>
            <RevisionIcon />
            <Styles.ItemName>Revision History</Styles.ItemName>
          </Styles.List>
        </Styles.ItemWrapper>
      )}
      <Styles.ItemWrapper>
        <Styles.List
          onClick={() => {
            logEvents('novels_chapter_cg_clicked', 'content_guidelines')
            handleNotionOrExternalLink(
              'https://writer.pocketnovel.com/content-and-community-guidelines'
            )
          }}
        >
          <ContentGuidelinesIcon />
          <Styles.ItemName> Content Guidelines</Styles.ItemName>
        </Styles.List>
      </Styles.ItemWrapper>
      <Styles.ItemWrapper>
        <Styles.List
          onClick={() => {
            logEvents('novels_chapter_wg_clicked', 'writing_guide')
            handleNotionOrExternalLink(
              'https://pocketnovel.notion.site/Writing-Tips-468f0ab41d964e3e8553c8129c5aa723'
            )
          }}
        >
          <WritingGuideIcon />
          <Styles.ItemName>Writing Guide</Styles.ItemName>
        </Styles.List>
      </Styles.ItemWrapper>
      <Styles.ItemWrapper>
        <Styles.List
          as={Link}
          to="/faqs"
          onClick={() => {
            logEvents('novels_chapter_faq_clicked', 'faq')
          }}
        >
          <FaqIcon />
          <Styles.ItemName>FAQ</Styles.ItemName>
        </Styles.List>
      </Styles.ItemWrapper>
      <PreviewPopup
        show={showPreview}
        close={() => setShowPreview(false)}
        user={user}
        novelDetails={novelDetails}
        chapter_id={chapter_id}
        isPreviewFromThreeDotsMenu={showPreview}
        withCloseMark
        head={
          <Styles.PreviewHeadWrapper>
            <Styles.HeadTitleText>
              {title.length > 0 ? title : 'Untitled Chapter'}
            </Styles.HeadTitleText>
          </Styles.PreviewHeadWrapper>
        }
      >
        <Styles.Body dangerouslySetInnerHTML={createPreview()}></Styles.Body>
      </PreviewPopup>
    </Styles.MenuWrapper>
  )
}

export default ThreeDotsDropdownMenu
